import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { StopWatchComponent } from '../stop-watch/stop-watch.component';
import { newJob } from '../model/newJob';

const getMVAdetail_url = `${environment.apiUrl}/getmvadetails`;
const getAllDetailsByJobID_url = `${environment.apiUrl}/getjobdetails`;
const saveJob_url=`${environment.apiUrl}/savejob`;
const getwwidDetails_url=`${environment.apiUrl}/getwwiddetails`
const getUserDetails_url=`${environment.apiUrl}/getuserdetails`
const updatePassword_url=`${environment.apiUrl}/PwaUpdatepasswordnew`
const getJobDetailsByUser_url=`${environment.apiUrl}/GetJobDetailsByUser?User=`;
const saveComment_url=`${environment.apiUrl}savecomments`;
const updateBatch_url=`${environment.apiUrl}InsertPWAMDSYSUpdateBatch`;
const GetRepairOrderPMSegmentList_url=`${environment.apiUrl}GetRepairOrderPMSegmentList`;
const GetSubletSupplierList_url=`${environment.apiUrl}GetSubletSupplierList`;
const InserSubletSpplier_url=`${environment.apiUrl}InsertSubletSupplier`;

//const loginService_url=`${}`
@Injectable({ providedIn: 'root' })
export class NewJobService {
  constructor(private http: HttpClient) {}

  getUserDetails(username:string)
    {
  
      return this.http.get(`${getUserDetails_url}/${username}`);
    }
    updatePassword(username:string,password:any)
    {
      return this.http.put(`${updatePassword_url}/${username}/${password}`,'');
    }

  getByMVA(id: string) {
    return this.http.get(`${getMVAdetail_url}/${id}`);
  }
  getByMVA1(id: string) {
    return this.http.get(`${getMVAdetail_url}/${id}`);
  }

  getJobDetailsByUser(id: string) {
    return this.http.get(`${getJobDetailsByUser_url}${id}`);
  }
  

//to get Job List according to wwid
getAllJobListByWWID(wwid:number,jobType:string)
{
  return this.http.get(`${getwwidDetails_url}/${wwid}?jobType=${jobType}`);
}

  //we will store id which we are getting in storeJobIdOnNewService() into jobId
  jobId: any;
  //we call this method from selectFeature to get AllDetails by job id for AutoPopulate senario
  storeJobIdOnNewService(id: any){
    this.jobId = String(id);
    //console.log(this.jobId)
    return this.http.get(`${getAllDetailsByJobID_url}/${this.jobId}`);
  }

  postData(newJobObjectPassedFromSelectFeatureComponetforPOST:newJob)
  {
  
     return this.http.post(`${saveJob_url}`,newJobObjectPassedFromSelectFeatureComponetforPOST);
     
  }
  saveCommentData(newJobObj:newJob)
  {
  
     return this.http.post(`${saveComment_url}`,newJobObj);
     
  }
  // insertPWAMDSYSUpdateBatch(RepairOrderId:any,WWID:any,EmployeeName:string,MVA:string,REGO:string,MODEL:string,KM:string,
  //   StartTime:string,EndTime:string,STATUS:any,RADIOBUTTON:string,Country:string,State:string,MAKE_MDL:string,Comment:string)
  // {
  //   return this.http.put(`${updateBatch_url}/${username}/${password}`,'');
  // }
  insertPWAMDSYSUpdateBatch(data:any)
  {
    return this.http.post(`${updateBatch_url}`,data);
  }
  GetRepairOrderPMSegmentList() {
    return this.http.get(`${GetRepairOrderPMSegmentList_url}`);
  }
  GetSubletSupplierList(supplier_name: any){
     const payload = { SupplierName: supplier_name };
    return this.http.post(`${GetSubletSupplierList_url}`,payload);
  }
  insertSubletSupplier(country:any, supplier_name:any)
  {
    const payload = { Country: country, SupplierName: supplier_name };
    return this.http.post(`${InserSubletSpplier_url}`,payload);
  }

}
